import { render } from "./LicensePageMetaContentRegular.vue?vue&type=template&id=7cdc0772&ts=true"
import script from "./LicensePageMetaContentRegular.vue?vue&type=script&lang=ts"
export * from "./LicensePageMetaContentRegular.vue?vue&type=script&lang=ts"

import "./LicensePageMetaContentRegular.vue?vue&type=style&index=0&id=7cdc0772&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__